<template>
  <v-row wrap>
    <v-col cols="12">
      <grid-c
        :gridConfig="grid"
        title="Daftar Informasi"
        add
        search
        id-key
        filter
        refresh
        addText="Informasi"
        @refresh="load"
        @filter="filter"
        :items="items"
        footerLabel="Informasi"
        :variablePencarian="['nama']"
        @search="
          search => {
            dataPencarian = search;
            load();
          }
        "
        :page="page"
        @change:page="
          pg => {
            cp = pg;
            load();
          }
        "
        @add="add"
        footer
      >
      </grid-c>
    </v-col>
    <ChangeDlg ref="dlg" />
  </v-row>
</template>

<script>
import { ALERT_INFO, PASSPORT } from "@/const";
import { isCan } from "@/tools";
import ChangeDlg from "../components/Form.vue";
import FilterKelas from "@/filter/FilterKelas.vue";

//@group Informasi
export default {
  name: "informasi-list",
  components: {
    ChangeDlg,
    FilterKelas
  },
  data() {
    return {
      alert: ALERT_INFO,
      items: [],
      peran: null,
      dataPencarian: null,
      page: null,
      cp: 1,
      more_menu: [
        // eslint-disable-next-lint
        {
          title: "Publikasi",
          icon: "mdi-check",
          color: "success",
          click: (i, o) => this.publikasi(o),
          check: (i, o) => (o.status == 0 && this.current_user.is_super_admin ? true : false)
        },
        {
          title: "Batal Publikasi",
          icon: "mdi-close",
          color: "error",
          click: (i, o) => this.batalPublikasi(o),
          check: (i, o) => (this.current_user.is_super_admin && o.status == 1 ? true : false)
        },
        {
          title: "Ubah",
          icon: "mdi-pencil",
          color: "orange",
          click: (i, o) => this.edit(o)
        },
        {
          title: "Hapus",
          icon: "mdi-delete",
          color: "error",
          click: (i, o) => this.hapus(o)
        }
      ]
    };
  },
  computed: {
    grid() {
      const conf = [
        {
          header: "Seri",
          name: "instansi.nama",
          align: "left",
          class: "subtitle-2",
          type: "string",
          cols: 12,
          sm: 12,
          md: 2,
          lg: 2,
          conditional: {
            vIf: o => o.instansi
          }
        },
        {
          header: "Seri",
          text: "Informasi Publik",
          align: "left",
          class: "subtitle-2",
          type: "string",
          cols: 12,
          sm: 12,
          md: 2,
          lg: 2,
          conditional: {
            vIf: o => !o.instansi
          }
        },
        {
          header: "Judul",
          name: "judul",
          align: "left",
          type: "string",
          cols: 12,
          sm: 12,
          md: 4,
          lg: 4
        },
        {
          header: "Model",
          name: "jenis",
          align: "left",
          type: "customLabel",
          cols: 12,
          sm: 12,
          md: 2,
          lg: 2
        },
        {
          header: "Status",
          name: "status",
          keterangan: "status",
          statusColor: this.$informasi,
          align: "left",
          class: "caption",
          type: "label",
          cols: 12,
          sm: 12,
          md: 2,
          lg: 2
        },
        {
          header: "Aksi",
          type: "more",
          more: this.more_menu,
          cols: 1,
          sm: 1,
          md: 1,
          lg: 1
        }
      ];
      return conf;
    },
    headers() {
      const a = [
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", sortable: false }
      ];
      return a;
    },
    //@vuese
    //pengecekan apakah memiliki akses kelola kelas (CRUD kelas)
    addData() {
      return isCan("kelas");
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    //@vuese
    //kembali ke halaman kelola seri
    toDashboard() {
      this.$router.push({ name: "instansi.pilih.admin" });
    },
    //@vuese
    //menampilkan daftar informasi sesuai instansi aktif dan parameter yang digunakan
    load() {
      var params = {
        page: this.cp,
        peran: this.peran
      };
      if (this.dataPencarian) {
        params[this.dataPencarian.param] = this.dataPencarian.s;
      }
      return this.$store
        .dispatch("informasi/get", {
          params: params
        })
        .then(res => {
          this.page = res;
          this.items = res.data;
        })
        .catch(e => e);
    },
    filter(data) {
      this.peran = data.peran;
      this.load();
    },
    //@vuese
    //tampilkan form input informasi
    add() {
      this.$refs.dlg.open().then(() => {
        this.load();
      });
    },
    //@vuese
    //tampilkan form edit informasi
    // @args objek informasi
    edit(item) {
      this.$refs.dlg.open(item).then(() => {
        this.load();
      });
    },
    //@vuese
    //publikasikan informasi
    // @args objek informasi
    publikasi(item) {
      this.$confirm(
        `Apakah Anda yakin akan mempublikasi informasi ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.judul}<br>
        </div>`
      )
        .then(() => this.$store.dispatch("informasi/publish", item))
        .then(res => {
          if (res.error) {
            this.$error("Publikasi informasi " + item.judul + " gagal");
          } else {
            this.$info("Publikasi informasi " + item.judul + " berhasil");
          }
        })
        .then(() => this.load())
        .catch(e => e);
    },
    //@vuese
    //batal publikasi informasi
    // @args objek informasi
    batalPublikasi(item) {
      this.$confirm(
        `Apakah Anda yakin akan membatalkan publikasi informasi ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.judul}<br>
        </div>`
      )
        .then(() => this.$store.dispatch("informasi/unpublish", item))
        .then(res => {
          if (res.error) {
            this.$error("Batal Publikasi informasi gagal");
          } else {
            this.$info("Batal Publikasi informasi " + item.judul + " berhasil");
          }
        })
        .then(() => this.load())
        .catch(e => e);
    },
    //@vuese
    //hapus informasi
    // @args objek informasi
    hapus(item) {
      this.$confirm(
        `Apakah Anda yakin akan menghapus Informasi ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.judul}<br>
        </div>`
      )
        .then(() => this.$store.dispatch("informasi/drop", item))
        .then(() => {
          this.$info("Informasi " + item.judul + " berhasil dihapus");
        })
        .then(() => this.load())
        .catch(e => e);
    },
    //@vuese
    //menuju link lms
    // @args objek kelas
    toCourse(val) {
      window.open(PASSPORT + val.link_learndash, "_blank");
    },
    cVal(obj, a) {
      if (obj[a] == 0) {
        return "DRAFT";
      } else if (obj[a] == 1) {
        return "TERBIT";
      }
    }
  },
  watch: {
    instansi_id() {
      this.load();
      this;
    }
  }
};
</script>

<style scoped>
.informasi {
  max-width: 200px;
}
</style>
